import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmComponent, WfDialogService } from 'wflow-ui';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { PeppolAction } from '../interfaces/peppol-action.interface';
import { PeppolRejectDialogComponent } from '../components/peppol-reject-dialog/peppol-reject-dialog.component';
import { PeppolRejectRequest } from '../interfaces/peppol-item.dto';

@Injectable()
export class PeppolStatusDialogService {
  private readonly dialogSvc = inject(WfDialogService);
  private readonly translateSvc = inject(TranslateService);

  confirm(action: PeppolAction): Observable<boolean> {
    return this.dialogSvc
      .open(DialogConfirmComponent, {
        width: '400px',
        data: {
          icon: 'alert-triangle',
          color: 'warn',
          header: this.translateSvc.instant(
            'PEPPOL.CONFIRM_STATUS_DIALOG.Title',
          ),
          content: this.translateSvc.instant(
            'PEPPOL.CONFIRM_STATUS_DIALOG.Text',
            {
              status: this.translateSvc.instant(`PEPPOL.ACTIONS.${action}`),
            },
          ),
          buttonYesText: this.translateSvc.instant(
            'PEPPOL.CONFIRM_STATUS_DIALOG.Submit',
          ),
          buttonNoText: this.translateSvc.instant('ConfirmDialogCancel'),
        },
      })
      .afterClosed()
      .pipe(take(1), filter(Boolean));
  }

  collectRejection(): Observable<PeppolRejectRequest> {
    return this.dialogSvc
      .open<PeppolRejectDialogComponent, never, PeppolRejectRequest>(
        PeppolRejectDialogComponent,
        {
          title: this.translateSvc.instant('PEPPOL.REJECT_DIALOG.Title'),
          width: '600px',
        },
      )
      .afterClosed()
      .pipe(take(1), filter(Boolean));
  }
}
